import React, { Component } from 'react';
//import InfiniteScroll  from 'react-infinite-scroller'
import InfiniteScroll from "react-infinite-scroll-component";

import { useNavigate, useParams } from 'react-router-dom';
import { createNewHeaders, updateHeaders, clientSettings, executeGet, executePost } from '../functions/Kubuku';

import { Link } from 'react-router-dom';
import { LIST_KATEOGRI, BERANDA_UTAMA, BERANDA, ADD_CART, ADD_WISHLIST, PREVIEW_CONTENT, GET_FAVORITE, GET_MORECONTEN } from '../api';
import SectionBook from '../components/SectionBook';
import SectionBookFlash from '../components/SectionBookFlash';
import SectionBookPromo from "../components/SectionBookPromo";
import SectionBookFavorite from "../components/SectionBookFavorite";
import SectionBookVertical from "../components/SectionBookVertical";
import CardKategori from '../components/CardKategori';
import ModalLoading from "../components/ModalLoading";
import ModalPopup from "../components/ModalPopup";
import Header from '../components/Header';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import MetaTags from '../components/MetaTags';

var randomColor = require('randomcolor');
const namaToko = localStorage.getItem('namaToko');

class Home extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isModal: false, //popup loading
      showMain: false,
      param: this.props.params,
      data: '',
      dataFavorite: [],
      topkategori: [],
      dataTop1: '',
      dataTop2: '',
      dataTop3: '',
      flagData: false,
      showModal: false, //popup preview
      showAge: false,
      urlPreview: '',
      msg: 'Berhasil',
      tanggal_lahir: '',
      kode_konten: '',
      data_more: [],
      index: '',
      next_data: true,
      kode_beranda: '',
      dataBanner: '',
      dataKategori: '',
      infIndex: 0,
      btnMore: "none",
      judul: '',
      harga: '',
      dataPreview: '',
      topEtalase: ''
    }
    this.beranda = this.beranda.bind(this);
    this.viewBook = this.viewBook.bind(this);
  }

  componentDidMount = async () => {
    console.log("DIDMOUNT--------->>>>>>>");
    localStorage.setItem('namaOutlet', "");
    if (this.state.param.id != undefined) {
      this.berandaWithId();
    } else {
      this.beranda();
    }
    //this.getListCategories();

  };

  beranda = async () => {
    try {
      const flagOpen = localStorage.getItem('flagOpen');
      //console.log("flagOpen = " + flagOpen);
      if (flagOpen != "1") {
        createNewHeaders('', '');
      } else {
        updateHeaders('', '');
      }
      const json = await executeGet(BERANDA_UTAMA);
      console.log("beranda utama = " + JSON.stringify(json));
      if (json.code == 200) {
        localStorage.setItem('namaOutlet', json.data.judul);
        localStorage.setItem("beranda", json.data.kode);

        this.setState({
          showMain: true,
          data: json.data,
          dataTop1: json.data.data_top1,
          dataTop2: json.data.data_top2,
          dataTop3: json.data.data_top3,
          dataFavorite: json.data.data_favorite,
          topEtalase: json.data.data_topkategori,
          flagData: true,
          kode_beranda: json.data.kode,
          dataBanner: json.data.data_banner,
          dataKategori: json.data.data_kategori
        }, () => {
          // console.log(this.state.dataTop2.Judul); 
        });
      }
    } catch (error) {
      //console.log(error);
      this.setState({ isLoading: false, isError: true, msg: "Network Error!" });
    }
    this.getSection();

  }

  berandaWithId = async () => {
    try {

      const flagOpen = localStorage.getItem('flagOpen');
      //console.log("flagOpen = " + flagOpen);
      if (flagOpen != "1") {
        createNewHeaders('', '');
      } else {
        updateHeaders('', '');
      }
      const json = await executeGet(BERANDA + this.state.param.id);

      console.log("berandaWithId = " + JSON.stringify(json));
      if (json.code == 200) {
        localStorage.setItem('namaOutlet', json.data.judul);
        localStorage.setItem("beranda", this.state.param.id);

        //console.log("berandaWithId 2 = " + JSON.stringify(json.data));
        this.setState({
          showMain: true,
          data: json.data,
          dataTop1: json.data.data_top1,
          dataTop2: json.data.data_top2,
          dataTop3: json.data.data_top3,
          topEtalase: json.data.data_topkategori,
          dataFavorite: json.data.data_favorite,
          flagData: true,
          kode_beranda: json.data.kode,
          dataBanner: json.data.data_banner,
          dataKategori: json.data.data_kategori
        }, () => {
          //console.log(this.state.data);
        });
      }
    } catch (error) {
      //console.log(error);
      this.setState({ isLoading: false, isError: true, msg: "Network Error!" });
    }
  }

  getListCategories = async () => {
    try {
      const flagOpen = localStorage.getItem('flagOpen');
      //console.log("flagOpen = " + flagOpen);
      if (flagOpen != "1") {
        createNewHeaders('', '');
      } else {
        updateHeaders('', '');
      }

      const json = await executeGet(LIST_KATEOGRI);
      // console.log("list_kategori = " + JSON.stringify(json));
      //alert(JSON.stringify(json));
      if (json.code == 200) {
        this.setState({
          topkategori: json.data[0]
        }, () => {
          //console.log("getListKategori = " + JSON.stringify(this.state.data)); 
        });
      }
    } catch (error) {
      //console.log(error);
      // this.setState({ isLoading: false, isError: true, msg: "Network Error!" });
    }
  }

  addCart = async (item) => {
    this.setState({ isLoading: true });
    //console.log('addCart home = ' + item.kode_konten);
    //console.log('addCart home = ' + item.id);
    try {
      let formData = new FormData();
      formData.append("kode_konten", item.kode_konten);
      if (item.id) {
        formData.append("id_toko_beranda_konten", item.id);
      }

      const json = await executePost(ADD_CART, formData);
      //console.log("add_cart = " + JSON.stringify(json));
      if (json.code == 200) {
        if (json.mode == "free") {
          this.setState({ isLoading: false, isModal: true, msg: json.msg });
        } else {
          this.setState({ isLoading: false, isModal: true, msg: "Berhasil Menambahkan Keranjang" });
        }

      } else if (json.code == 500 || json.code == 505) {
        window.location.href = window.location.origin + "/login";
      } else {
        this.setState({ isLoading: false, isModal: false, isError: true, msg: json.msg });

      }
    } catch (error) {
      //console.log(error);
      this.setState({ isLoading: false, isError: true, msg: "Network Error!" });
    }

  }

  etalaseSection = async (item) => {
    //console.log("etalaseSection = " + item.kode_section);
    // localStorage.setItem('etalaseSection', JSON.stringify(item));
    //this.props.navigate('/etalase/' + item.kode_section);
    this.props.navigate("/" + this.state.kode_beranda + "/" + item.kode_section);
  }

  viewBook = async (data) => {
    try {
      const json = await executeGet(PREVIEW_CONTENT + data.kode_konten + '/0');
      // console.log("preview = " + JSON.stringify(json));
      //console.log(json);
      if (json.code == 200) {

        this.setState({ harga: data.formatted_harga_akhir, judul: data.judul, urlPreview: json.data.url + "&uid=" + localStorage.getItem('kode') + "&js=" + data.kode_konten, showModal: true, showAge: false, dataPreview: data });

      } else if (json.code == 404) {
        //masukkan tgl lahir
        this.setState({ showAge: true, showModal: true, kode_konten: data.kode_konten });
      } else if (json.code == 500 || json.code == 505) {
        this.setState({ showAge: true, showModal: true, kode_konten: data.kode_konten });
        window.location.href = window.location.origin + "/login";
      }
    } catch (error) {
      //console.log(error);
      this.setState({ isLoading: false, isError: true, msg: "Network Error!" });
    }
    // preview = 'pdf-sample.pdf';
    // this.setState({ urlPreview: 'https://kubuku.id/pdfpreview/reader.html?filename=' + preview, showModal: true });
  }

  addWishlist = async (kode_konten) => {
    //this.setState({ isLoading: true });
    try {
      let formData = new FormData();
      formData.append("kode_konten", kode_konten);
      const json = await executePost(ADD_WISHLIST, formData);
      if (json.code == 200) {
        // navigate to cart
        // this.props.navigate('/wishlist');
        this.setState({ isLoading: false, isModal: true, msg: "Berhasil Menambahkan ke Wishlist" });
      } else if (json.code == 500 || json.code == 505) {
        window.location.href = window.location.origin + "/login";
      } else {
        this.setState({ isLoading: false, isError: true, msg: json.msg });
      }
    } catch (error) {
      //console.log(error);
      this.setState({ isLoading: false, isError: true, msg: "Network Error!" });
    }

  }

  nextDetail = async () => {
    if (this.state.tanggal_lahir != "") {
      try {
        const json = await executeGet(PREVIEW_CONTENT + this.state.kode_konten + "/" + this.state.tanggal_lahir);
        if (json.code == 200) {
          // this.viewBook(this.state.kode_konten);
          this.setState({ showAge: false, urlPreview: json.data.url });
          // navigate to cart
          // this.props.navigate('/cart');
          // this.setState({showMain: true, data: json.data});
        }
      } catch (error) {
        //console.log(error);
        this.setState({ isError: true, errorMessage: "Network Error!" });
      }
    }

  }

  moreData = async () => {
    try {
      let index = "";
      let idx = "";
      //console.log("BERANDA: " + this.state.kode_beranda);
      if (this.state.index != ",undefined") idx = this.state.index;
      //console.log("INDEX "+this.state.index);
      let formData = new FormData();
      formData.append("beranda", this.state.kode_beranda);
      formData.append("index", idx);
      formData.append("limit", 8);

      let json = await executePost(GET_MORECONTEN, formData);
      //console.log("MORE CONTENT = " + JSON.stringify(json));

      if (json.code == 200) {
        var joinData = this.state.data_more;
        joinData = joinData.concat(json.data);

        index = json.idx;
        this.setState({
          data_more: joinData,
          index: index,
          next_data: true
        }, () => {
          //console.log("contentData = " + this.state.contentData);
        });
      } else if (json.cod = 404) {
        this.setState({ next_data: false });
      }

    } catch (error) {
      //console.log(error);
      this.setState({ isError: true, errorMessage: "Network Error!" });
    }
  }
  getSection = async () => {
    try {
      let idm = Number(this.state.infIndex);
      if (idm <= 3) {
        let index = "";
        let idx = "";
        //console.log("BERANDA: " + this.state.kode_beranda);
        if (this.state.index != ",undefined") idx = this.state.index;
        //console.log("INDEX "+this.state.index);
        let formData = new FormData();
        formData.append("beranda", this.state.kode_beranda);
        formData.append("index", idx);
        formData.append("limit", 6);

        let json = await executePost(GET_MORECONTEN, formData);
        //console.log("MORE CONTENT = " + JSON.stringify(json));

        if (json.code == 200) {
          var joinData = this.state.data_more;
          joinData = joinData.concat(json.data);

          index = json.idx;
          this.setState({
            data_more: joinData,
            index: index,
            next_data: true
          }, () => {
            //console.log("contentData = " + this.state.contentData);
          });
        } else if (json.cod = 404) {
          this.setState({ next_data: false });
        }
        idm = idm + 1;

        if (idm >= 3) {
          this.state.btnMore = "block";
        } else {
          this.state.btnMore = "none";
        }
        this.setState({
          infIndex: idm
        })
      }
    } catch (error) {
      //console.log(error);
      this.setState({ isError: true, errorMessage: "Network Error!" });
    }

  }


  render() {

    return (
      // this.state.isLoading ? <Loader />: 
      <div>
        <MetaTags
          title={namaToko}
          keywords='Membaca Tanpa Batas, Inspirasi Tanpa Akhir'
          description='Toko Buku Digital terdepan yang menawarkan ribuan judul buku dari berbagai genre dan penulis terkenal. Kami hadir untuk memberikan Anda akses mudah dan cepat ke dunia literasi tanpa batas, kapan saja dan di mana saja.'
          image='https://tokobukupintar.com/images/tokobukupintar.com.ico'
          name={window.location.hostname}
        />
        {
          this.state.isLoading &&
          <ModalLoading />
        }

        {this.state.showModal ? (
          <>
            <div>
              <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                <div className="relative lg:w-[90%] lg:h-[96%] lg:my-2 w-[100%] h-[100%] my-0 mx-auto">
                  {/*content*/}
                  <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none h-[98%]">
                    {/*header*/}
                    <div className="flex items-start justify-between p-2 border-b border-solid border-slate-200 rounded-t">
                      <div className="flex w-full justify-end">
                        <div className="w-[10%] cursor-pointer flex justify-end items-end">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" onClick={() => this.setState({ showModal: false })}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        </div>
                      </div>

                    </div>
                    {/*body*/}
                    <div className="relative pb-0 lg:pr-6 lg:pl-6 pr-0 pl-0 flex-auto">
                      {
                        this.state.showAge ?
                          <div className="lg:py-32 py-4 pt-10">
                            <div className="text-4xl font-semibold dark:text-black pb-14 text-center">Masukkan Tanggal Lahir Anda</div>
                            <div className="flex items-center justify-center">
                              <input type="date" onChange={event => this.setState({ tanggal_lahir: event.target.value })} className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-full focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5 dark:bg-gray-50 dark:border-gray-600 dark:placeholder-gray-400 dark:text-gray-900 dark:focus:ring-blue-500 dark:focus:border-blue-500 lg:w-6/12 w-full" placeholder="Select date" />
                            </div>
                            <div className="flex items-center justify-center pt-6">
                              <button type="button" onClick={this.nextDetail} className="w-full bg-greenWalang font-medium rounded-full text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 justify-center mr-2 lg:w-3/12 w-6/12 hover:shadow-[0_8px_25px_-8px_#8e8e8e]">
                                <div className="text-[#ffffff]">Lanjutkan</div>
                              </button>
                            </div>
                          </div>
                          :
                          <iframe src={this.state.urlPreview} title="Preview" height="100%" width="100%" className="w-full h-full"></iframe>
                      }
                    </div>

                    <div className="pl-5 pt-2 pb-2 flex">

                      <div className="float-left w-[80%]">
                        {this.state.judul}
                      </div>
                      <div className="pr-4 pl-4 float-right w-[20%] flex justify-end items-end">
                        <button onClick={() => this.addCart(this.state.dataPreview)} type="button" className="pl-6 bg-greenWalang font-medium rounded-full text-sm px-2 py-3 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 justify-center mr-2 hover:shadow-[0_8px_25px_-8px_#8e8e8e]">
                          <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.67655 10.9203L2.29772 10.8512L1.67655 10.9203ZM18.3239 10.9203L17.7027 10.8512L18.3239 10.9203ZM18.5704 8.70144L19.1916 8.77046L18.5704 8.70144ZM1.43001 8.70144L2.05119 8.63242L1.43001 8.70144ZM5.44216 7.89139C5.19809 7.64731 4.80236 7.64731 4.55828 7.89139C4.3142 8.13547 4.3142 8.5312 4.55828 8.77527L5.44216 7.89139ZM15.4422 8.77527C15.6862 8.5312 15.6862 8.13547 15.4422 7.89139C15.1981 7.64731 14.8024 7.64731 14.5583 7.89139L15.4422 8.77527ZM14.5002 8.83333L14.9422 9.27527L14.9422 9.27527L14.5002 8.83333ZM5.83619 4.85047L5.21158 4.82843L5.83619 4.85047ZM14.1658 4.90207L13.5409 4.91648L14.1658 4.90207ZM17.9493 8.63242L17.7027 10.8512L18.9451 10.9893L19.1916 8.77046L17.9493 8.63242ZM2.29772 10.8512L2.05119 8.63242L0.808833 8.77046L1.05537 10.9893L2.29772 10.8512ZM10.0002 17.7083C8.19603 17.7083 6.90214 17.7071 5.90864 17.5806C4.93217 17.4562 4.32965 17.2193 3.86755 16.8057L3.0339 17.7371C3.7583 18.3854 4.64287 18.6795 5.75069 18.8206C6.84148 18.9595 8.22908 18.9583 10.0002 18.9583V17.7083ZM1.05537 10.9893C1.24943 12.7358 1.40036 14.1051 1.65827 15.1673C1.92037 16.2468 2.31019 17.0893 3.0339 17.7371L3.86755 16.8057C3.40476 16.3914 3.10339 15.8214 2.87298 14.8724C2.63836 13.9061 2.49545 12.6308 2.29772 10.8512L1.05537 10.9893ZM17.7027 10.8512C17.505 12.6308 17.3621 13.9061 17.1275 14.8724C16.897 15.8214 16.5957 16.3914 16.1329 16.8057L16.9665 17.7371C17.6903 17.0893 18.0801 16.2468 18.3422 15.1673C18.6001 14.1051 18.751 12.7358 18.9451 10.9893L17.7027 10.8512ZM10.0002 18.9583C11.7714 18.9583 13.159 18.9595 14.2498 18.8206C15.3576 18.6795 16.2421 18.3854 16.9665 17.7371L16.1329 16.8057C15.6708 17.2193 15.0683 17.4562 14.0918 17.5806C13.0983 17.7071 11.8044 17.7083 10.0002 17.7083V18.9583ZM15.2575 5.625C16.1452 5.625 16.7452 5.62644 17.1884 5.68838C17.614 5.74784 17.7868 5.85026 17.8958 5.97196L18.8272 5.1383C18.4392 4.70487 17.9291 4.52973 17.3614 4.4504C16.8114 4.37356 16.1079 4.375 15.2575 4.375V5.625ZM19.1916 8.77046C19.2855 7.92527 19.3646 7.22616 19.349 6.67106C19.3329 6.09807 19.2151 5.57174 18.8272 5.1383L17.8958 5.97196C18.0047 6.09365 18.0874 6.27675 18.0995 6.70627C18.1121 7.15367 18.0473 7.75015 17.9493 8.63242L19.1916 8.77046ZM4.74296 4.375C3.89257 4.375 3.189 4.37356 2.63902 4.4504C2.07132 4.52973 1.5612 4.70487 1.17326 5.1383L2.10467 5.97196C2.2136 5.85026 2.38644 5.74784 2.81199 5.68838C3.25527 5.62644 3.85526 5.625 4.74296 5.625V4.375ZM2.05119 8.63242C1.95316 7.75015 1.88833 7.15367 1.90094 6.70627C1.91304 6.27675 1.99575 6.09365 2.10467 5.97196L1.17326 5.1383C0.785322 5.57174 0.66758 6.09807 0.651435 6.67106C0.635795 7.22616 0.714924 7.92527 0.808833 8.77046L2.05119 8.63242ZM5.94216 8.39139L5.44216 7.89139L4.55828 8.77527L5.05828 9.27527L5.94216 8.39139ZM14.5583 7.89139L14.0583 8.39139L14.9422 9.27527L15.4422 8.77527L14.5583 7.89139ZM5.05828 9.27527C7.78764 12.0046 12.2128 12.0046 14.9422 9.27527L14.0583 8.39139C11.8171 10.6326 8.18337 10.6326 5.94216 8.39139L5.05828 9.27527ZM4.74296 5.625H5.83355V4.375H4.74296V5.625ZM10.0002 0.208332C7.41129 0.208332 5.30213 2.26131 5.21158 4.82843L6.4608 4.8725C6.5277 2.97577 8.08689 1.45833 10.0002 1.45833V0.208332ZM5.21158 4.82843C5.20957 4.8854 5.20855 4.94259 5.20855 5H6.45855C6.45855 4.95729 6.45931 4.91479 6.4608 4.8725L5.21158 4.82843ZM10.0002 1.45833C11.9283 1.45833 13.4967 2.99921 13.5409 4.91648L14.7906 4.88766C14.7308 2.29302 12.609 0.208332 10.0002 0.208332V1.45833ZM13.5409 4.91648C13.5416 4.94423 13.5419 4.97207 13.5419 5H14.7919C14.7919 4.96246 14.7915 4.92501 14.7906 4.88766L13.5409 4.91648ZM5.83355 5.625H14.1669V4.375H5.83355V5.625ZM14.1669 5.625H15.2575V4.375H14.1669V5.625Z" fill="white" />
                          </svg>
                          <div className="text-[#ffffff] pr-4 pl-2 w-[120px]">
                            Rp {this.state.harga}
                          </div>
                        </button>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
            </div>
          </>
        ) : null}
        {
          this.state.isModal &&
          <ModalPopup
            messages={this.state.msg}
            press={() => { this.setState({ isModal: false }) }}
            type="success"
          />
        }
        {
          this.state.isError &&
          <ModalPopup
            messages={this.state.msg}
            press={() => { this.setState({ isError: false }) }}
            type="error"
          />
        }

        <div>
          {/* <Header />  */}
          <div className="hidden lg:block">

            <div className="pt-24 px-2 lg:px-8 xl:px-28 dark:bg-white pb-6">

              {/* {this.state.dataBanner.length > 0 &&
                <Carousel interval={5000} infiniteLoop={true} autoPlay={true} showArrows={true} showThumbs={false} showStatus={false} className="pb-4 dark:bg-white">
                  {

                    this.state.dataBanner.map(item => {
                      return (
                        <div className="cursor-pointer" onClick={() => this.props.navigate(item.url_banner)}>
                          <img className="max-w-full rounded-lg cursor-pointer" src={item.url_image} />
                        </div>
                      )
                    })
                  }
                </Carousel>
              } */}

              {this.state.topEtalase != '' ?
                <>
                  {this.state.topEtalase.data.length > 0 &&
                    <>
                      <div className="flex mb-2 mt-2">
                        <div className="w-[30%] font-semibold text-xl dark:text-black line-clamp-1">
                          Lebih cepat ke etalase
                        </div>
                        <div className="w-[70%] justify-center items-center">
                          <div className="border-[0.5px] border-grayWalang mt-5"></div>
                        </div>

                      </div>
                      <div className="pt-1 pl-4 dark:bg-white rounded-[10px] bg-[#f9f9f9] border-[0.25px] border-[#dadada]">
                        <div className="flex overflow-x-scroll hide-scroll-bar pb-2">
                          <div className="flex flex-nowrap">

                            {this.state.topEtalase.data.map(item => {

                              return (
                                <>
                                  {item.konten &&
                                    <>
                                      <div onClick={() => this.props.navigate('/' + this.state.param.id + '/' + item.kode)} className="flex flex col cursor-pointer mr-4 w-48 xl:w-[220px] line-clamp-1 pt-2 pb-1">
                                        <div>
                                          <center>
                                            <img className='w-[64px] h-[64px] rounded-[50%]' src={item.konten} alt="" />
                                          </center>
                                        </div>
                                        <div>
                                          <center>
                                            <div className='w-[96px] xl:w-[220px] text-sm break-words'>
                                              <center>
                                                {item.judul}
                                              </center>
                                            </div>
                                          </center>
                                        </div>
                                      </div>
                                    </>
                                  }
                                </>

                              )

                            })}

                          </div>
                        </div>
                      </div>
                    </>
                  }
                </>
                :
                <>
                  <div className="flex mb-2 mt-2">
                    <div className="w-[30%] font-semibold text-xl dark:text-black line-clamp-1">
                      Lebih cepat ke etalase
                    </div>
                    <div className="w-[70%] justify-center items-center">
                      <div className="border-[0.5px] border-grayWalang mt-5"></div>
                    </div>
                  </div>

                  <div className="pt-1 pl-4 dark:bg-white rounded-[10px] bg-[#f9f9f9] border-[0.25px] border-[#dadada] animate-pulse">
                    <div className="flex overflow-x-scroll hide-scroll-bar pb-2">
                      <div className="flex flex-nowrap">
                        <div className="flex flex col cursor-pointer mr-4 w-48 xl:w-[220px] line-clamp-1 pt-2 pb-1">
                          <center>
                            <div class="rounded-full bg-slate-200 w-[64px] h-[64px]"></div>
                            <div class="h-3 bg-slate-200 rounded mt-2"></div>
                          </center>
                        </div>

                        <div className="flex flex col cursor-pointer mr-4 w-48 xl:w-[220px] line-clamp-1 pt-2 pb-1">
                          <center>
                            <div class="rounded-full bg-slate-200 w-[64px] h-[64px]"></div>
                            <div class="h-3 bg-slate-200 rounded mt-2"></div>
                          </center>
                        </div>

                        <div className="flex flex col cursor-pointer mr-4 w-48 xl:w-[220px] line-clamp-1 pt-2 pb-1">
                          <center>
                            <div class="rounded-full bg-slate-200 w-[64px] h-[64px]"></div>
                            <div class="h-3 bg-slate-200 rounded mt-2"></div>
                          </center>
                        </div>

                        <div className="flex flex col cursor-pointer mr-4 w-48 xl:w-[220px] line-clamp-1 pt-2 pb-1">
                          <center>
                            <div class="rounded-full bg-slate-200 w-[64px] h-[64px]"></div>
                            <div class="h-3 bg-slate-200 rounded mt-2"></div>
                          </center>
                        </div>

                        <div className="flex flex col cursor-pointer mr-4 w-48 xl:w-[220px] line-clamp-1 pt-2 pb-1">
                          <center>
                            <div class="rounded-full bg-slate-200 w-[64px] h-[64px]"></div>
                            <div class="h-3 bg-slate-200 rounded mt-2"></div>
                          </center>
                        </div>
                      </div>
                    </div>
                  </div>


                </>
              }

              {
                this.state.topEtalase != '' &&
                <>
                  {
                    this.state.dataFavorite.data.length > 0 &&
                    <div className="pt-4 dark:bg-white  mb-8">
                      <div className="flex mb-4">
                        <div className="w-[30%] font-semibold text-xl dark:text-black line-clamp-1">
                          {this.state.dataFavorite.judul}
                        </div>
                        <div className="w-[70%] justify-center items-center">
                          <div className="border-[0.5px] border-grayWalang mt-5"></div>
                        </div>

                      </div>
                      <div className="flex overflow-x-scroll hide-scroll-bar ">

                        <div className="flex flex-nowrap">
                          <div className="w-[240px] mb-0 inline-block product-wrap rounded-[10px] bg-[#0B1C38]">
                            <img className="w-[170px] h-[330px] rounded-[10px]" src={localStorage.getItem("poster")}></img>
                          </div>
                          <div className="mt-2 mb-2 pt-2 pb-2 flex flex-nowrap ml-[-90px]">

                            {this.state.dataFavorite.data.map(item => {
                              return (
                                <SectionBookFlash
                                  data={item}
                                  beranda={this.state.kode_beranda}
                                  addWishlist={() => { this.addWishlist(item.kode_konten) }}
                                  addCart={() => { this.addCart(item) }}
                                  viewBook={() => { this.viewBook(item) }}
                                />
                              )
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </>
              }

              {
                this.state.dataTop1 != '' &&
                <>
                  <div className="flex pb-10 dark:bg-white">
                    <div className="w-9/12">
                      {/* hot deals */}



                      {
                        this.state.dataTop1.data.length > 0 &&
                        <>
                          <div className="flex">
                            <div className="w-[25%] font-semibold text-xl dark:text-black line-clamp-1">
                              {this.state.dataTop1.judul}
                            </div>
                            <div className="w-[53%] justify-center items-center">
                              <div className="border-[0.5px] border-grayWalang mt-5"></div>
                            </div>
                            <div className="w-[180px] flex justify-end">
                              <button onClick={() => this.props.navigate('/' + this.state.data.kode + '/promosi')} type="button" className="bg-greenWalang font-medium rounded-full text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 justify-center mr-2 hover:shadow-[0_8px_25px_-8px_#8e8e8e]">
                                <div className="text-[#ffffff]">
                                  Lihat Semua
                                </div>

                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2 -mr-1" fill="none" viewBox="0 0 24 24" stroke="#ffffff" strokeWidth="2">
                                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                </svg>
                              </button>
                            </div>
                          </div>
                          <div className="flex overflow-x-scroll pb-10 hide-scroll-bar mr-6">
                            <div className="flex flex-nowrap mt-6">
                              {
                                this.state.dataTop1.data.map(item => {

                                  return (
                                    <SectionBookPromo
                                      data={item}
                                      beranda={this.state.kode_beranda}
                                      section={'promosi'}
                                      addWishlist={() => { this.addWishlist(item.kode_konten) }}
                                      addCart={() => { this.addCart(item) }}
                                      viewBook={() => { this.viewBook(item) }}
                                    />
                                  )


                                })
                              }

                            </div>
                          </div>
                        </>
                      }
                      {/* end hot deals */}

                      {/* Buku Populer */}
                      {this.state.dataTop2.data.length > 0 &&
                        <>
                          <div className="flex">
                            <div className="w-[25%] font-semibold text-xl dark: text-black line-clamp-1">
                              {this.state.dataTop2.Judul}
                            </div>
                            <div className="w-[53%] justify-center items-center">
                              <div className="border-[0.5px] border-grayWalang mt-5"></div>
                            </div>
                            <div className="w-[180px] flex justify-end">
                              <button onClick={() => this.props.navigate('/' + this.state.data.kode + '/highlight')} type="button" className="bg-greenWalang font-medium rounded-full text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 justify-center mr-2 hover:shadow-[0_8px_25px_-8px_#8e8e8e]">
                                <div className="text-[#ffffff]">
                                  Lihat Semua
                                </div>

                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2 -mr-1" fill="none" viewBox="0 0 24 24" stroke="#ffffff" strokeWidth="2">
                                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                </svg>
                              </button>
                            </div>
                          </div>
                          <div className="flex overflow-x-scroll pb-1 hide-scroll-bar mr-6">
                            <div className="flex flex-nowrap mt-6">
                              {
                                this.state.dataTop2.data.map(item => {
                                  return (
                                    <SectionBookFavorite
                                      data={item}
                                      beranda={this.state.kode_beranda}
                                      section={'highlight'}
                                      addWishlist={() => { this.addWishlist(item.kode_konten) }}
                                      addCart={() => { this.addCart(item) }}
                                      viewBook={() => { this.viewBook(item) }}
                                    />
                                  )
                                })
                              }
                            </div>
                          </div>
                        </>
                      }
                      {/* end Buku Populer */}

                    </div>
                    <div className="w-3/12">
                      <div className="w-full pb-4 h-full max-w-xs overflow-hidden rounded-[10px] bg-[#F0F1F5]">
                        <div className="text-center my-1 text-xl text-semibold">
                          Top 5 Bulan Ini
                        </div>

                        {
                          this.state.dataTop3.data.map((item, index) => {
                            return (
                              <SectionBookVertical
                                beranda={this.state.kode_beranda}
                                section={'best'}
                                data={item}
                                index={index}
                              />
                            )
                          })
                        }

                      </div>
                    </div>
                  </div>
                </>
              }

              {
                this.state.flagData &&
                <>
                  {
                    this.state.data.data.map(item => {
                      if (item.tipe == "banner") {

                        return (
                          <div>
                          </div>
                        )
                      } else {
                        return (
                          <div className="pt-0 dark:bg-white">
                            {/* Buku Populer */}
                            <div className="flex">
                              <div className="w-[40%] font-semibold text-xl dark:text-black">
                                {item.judul}
                              </div>
                              <div className="w-[40%] xl:w-[55%] justify-center items-center">
                                <div className="border-[0.5px] border-grayWalang mt-5"></div>
                              </div>
                              <div className="w-[180px] flex justify-end">
                                <button onClick={() => { this.etalaseSection(item) }} type="button" className="bg-greenWalang font-medium rounded-full text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 justify-center mr-2 hover:shadow-[0_8px_25px_-8px_#8e8e8e]">
                                  <div className="text-[#ffffff]">
                                    Lihat Semua
                                  </div>

                                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2 -mr-1" fill="none" viewBox="0 0 24 24" stroke="#ffffff" strokeWidth="2">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                  </svg>
                                </button>
                              </div>
                            </div>
                            <div className="flex overflow-x-scroll pb-10 hide-scroll-bar">
                              <div className="flex flex-nowrap mt-6">
                                {item.data.map(items => {
                                  return (
                                    <SectionBook
                                      path={"/" + this.state.kode_beranda + "/" + item.kode_section}
                                      data={items}
                                      addWishlist={() => { this.addWishlist(items.kode_konten) }}
                                      addCart={() => { this.addCart(items) }}
                                      viewBook={() => { this.viewBook(items) }}
                                    />
                                  )
                                })}
                              </div>
                            </div>
                          </div>

                        )
                      }
                    })
                  }
                </>
              }

            </div>
          </div>



          {/* infinit content*/}
          <div className="hidden lg:block">
            <div className="pt-1 px-8 xl:px-28 dark:bg-white">
              <div className="flex overflow-x-scroll hide-scroll-bar pb-4">
                <div className="flex flex-nowrap">

                  {this.state.topkategori.map(item => {
                    let warna = randomColor({ luminosity: 'dark', count: 1 });

                    return (

                      <div style={{ background: warna }} onClick={() => this.props.navigate('/categorieDetail/' + item.id_kategori)} className={"flex flex-col cursor-pointer w-48 pl-4 pr-4 pt-2 pb-1 ml-2 mr-2 border-[0.25px] border-[#d8d8d8] rounded-[5px]"}>
                        <center>
                          <div>
                            <img className='w-[64px] h-[64px] rounded-[50%] border-[1px] border-white' src={item.cover}></img>
                          </div>
                          <div className='line-clamp-1 text-sm text-white'>{item.kategori}</div>
                        </center>
                      </div>


                    )
                  })}

                </div>
              </div>
            </div>
            <InfiniteScroll
              dataLength={this.state.data_more.length}
              next={this.getSection}
              hasMore={this.state.next_data}
            >

              <div className="pt-1 px-8 xl:px-28 dark:bg-white">

                <div className="flex pb-[4px] space-x-7">
                  <div className="w-full">
                    <div className="grid grid-cols-8 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 py-[30px]">
                      {this.state.data_more.map(item => {
                        let listid = this.state.index;
                        //if (listid.includes(item.id)==false) {
                        return (
                          <CardKategori
                            beranda={this.state.param.id}
                            section={"infinite"}
                            data={item}
                          />
                        )
                        //}
                      })}
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-center">
                <center>
                  <button type="button" onClick={() => this.moreData()} style={{ display: this.state.btnMore }} className="bg-greenWalang text-[#ffffff] pr-4 font-medium rounded-full text-sm px-5 my-4 py-3 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 justify-center mr-2 hover:shadow-[0_8px_25px_-8px_#8e8e8e]">Tampilkan lebih banyak</button>
                </center>
              </div>
            </InfiniteScroll>

          </div>

          <div className="block lg:hidden">
            <div className="dark:bg-white pt-2">
              <div className="flex overflow-x-scroll hide-scroll-bar pb-2">
                <div className="flex flex-nowrap">

                  {this.state.topkategori.map(item => {
                    let warna = randomColor({ luminosity: 'dark', count: 1 });
                    let cwarna = "bg-[" + warna + "]";

                    return (

                      <div style={{ backgroundColor: warna }} onClick={() => this.props.navigate('/categorieDetail/' + item.id_kategori)} className={"flex flex-col cursor-pointer w-40 pl-4 pr-4 pt-2 pb-1 ml-2 mr-2 border-[0.25px] border-[#d8d8d8] rounded-[5px]"}>
                        <center>
                          <div>
                            <img className='w-[52px] h-[52px] rounded-[50%] border-[1px] border-white' src={item.cover}></img>
                          </div>
                          <div className='line-clamp-1 text-xs text-white'>{item.kategori}</div>
                        </center>
                      </div>


                    )
                  })}

                </div>
              </div>
            </div>
            <InfiniteScroll
              dataLength={this.state.data_more.length}
              next={this.getSection}
              hasMore={this.state.next_data}
            >
              <div className="pt-1 px-2 dark:bg-white">

                <div className="flex pb-[4px] space-x-7">
                  <div className="w-full h-[75%]">

                    <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 py-[30px]">
                      {this.state.data_more.map(item => {
                        return (
                          <CardKategori
                            beranda={this.state.param.id}
                            section={"infinite"}
                            data={item}
                          />
                        )
                      })}
                    </div>

                  </div>
                </div>
              </div>
              <div className="text-center mb-[88px]">
                <center>
                  <button type="button" onClick={() => this.moreData()} style={{ display: this.state.btnMore }} className="bg-greenWalang text-[#ffffff] pr-4 font-medium rounded-full text-sm px-5 my-4 py-3 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 justify-center mr-2 hover:shadow-[0_8px_25px_-8px_#8e8e8e]">Tampilkan lebih banyak</button>
                </center>
              </div>
            </InfiniteScroll>

          </div>
        </div>

      </div>
    );

  }
}

// export default Home;

function WithNavigate(props) {
  let navigate = useNavigate();
  return <Home {...props} navigate={navigate} params={useParams()} />
}

export default WithNavigate;
